import { jsx as _jsx } from "react/jsx-runtime";
var Play = function Play(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1.03125 * size,
    height: size,
    viewBox: "0 0 33 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M28.307 18.432l-20.723 12.946c-0.464 0.289-0.996 0.436-1.524 0.436-0.481 0-0.961-0.119-1.395-0.359-0.915-0.509-1.485-1.473-1.485-2.521v-25.894c0-1.048 0.569-2.012 1.485-2.517 0.915-0.512 2.031-0.48 2.918 0.074l20.723 12.949c0.841 0.527 1.352 1.452 1.352 2.443 0 0.994-0.512 1.913-1.352 2.443z"
    })
  });
};
export default Play;